import { render, staticRenderFns } from "./relatedBy.vue?vue&type=template&id=5553f2af&scoped=true"
import script from "./relatedBy.vue?vue&type=script&lang=js"
export * from "./relatedBy.vue?vue&type=script&lang=js"
import style0 from "./relatedBy.vue?vue&type=style&index=0&id=5553f2af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5553f2af",
  null
  
)

export default component.exports